import { render } from "./KaimonoList.vue?vue&type=template&id=f8f82110"
import script from "./KaimonoList.vue?vue&type=script&lang=js"
export * from "./KaimonoList.vue?vue&type=script&lang=js"

import "./KaimonoList.vue?vue&type=style&index=0&id=f8f82110&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__